export default function MetricCard({ label, value, sub, valueColor }) {
  return (
    <div className="met">
      <div className="mlbl">{label}</div>
      <div className="mval" style={valueColor ? { color: valueColor } : {}}>{value ?? '—'}</div>
      <div className="msub">{sub}</div>
    </div>
  );
}
